import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React, { useMemo } from "react";

import { useBookingBarContext } from "../booking_bar_provider";
import { ItemGroups } from "./item_groups";

const MONDAY = 1;

export const WeeksOverlay = () => {
  const {
    bar: { start, end },
    draggingMode,
    draggingStartDate,
    draggingEndDate
  } = useBookingBarContext();
  const { utc, formatISODate } = useDateFormatter();

  const weeks = useMemo<{ date: string; hidden: boolean }[][]>(() => {
    let barStart = start;
    let barEnd = end;
    if (draggingMode) {
      barStart =
        new Date(formatISODate(draggingStartDate)).getTime() < new Date(formatISODate(start)).getTime()
          ? draggingStartDate
          : start;
      barEnd =
        new Date(formatISODate(draggingEndDate)).getTime() > new Date(formatISODate(end)).getTime()
          ? draggingEndDate
          : end;
    }
    const daysCount = utc(formatISODate(utc(barEnd))).diff(utc(formatISODate(utc(barStart))), "days") + 1;
    const weeks: { date: string; hidden: boolean }[][] = [[]];
    let weekIndex = 0;
    for (let dayIndex = 0; dayIndex < daysCount; dayIndex++) {
      const currentDay = utc(barStart).add(dayIndex, "days");
      if (dayIndex !== 0 && currentDay.isoWeekday() === MONDAY) {
        weeks.push([]);
        weekIndex++;
      }
      weeks[weekIndex].push({
        date: formatISODate(currentDay),
        hidden: !currentDay.isBetween(utc(draggingStartDate), utc(draggingEndDate), undefined, "[]")
      });
    }
    return weeks;
  }, [start, end, utc, formatISODate, draggingMode, draggingStartDate, draggingEndDate]);

  return <ItemGroups dateGroups={weeks} />;
};
